import { SystemNotificationPanel } from "@modules/notification/screens/system-notification/SystemNotificationPanel.tsx";

export const NotificationNavButton: React.FunctionComponent = () => {
  return <SystemNotificationPanel />;
};
